import _SdCommonModel from "../commons/SdCommonModel";
import _SdCommonModelComputation from "../commons/SdCommonModelComputation";
import _SdCommonsTicket from "../commons/SdCommonsTicket";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverRequestQueryModelComputationStatus = exports.ShapeDiverRequestQueryModelStatus = exports.ShapeDiverRequestModelComputationQueryType = exports.ShapeDiverRequestModelComputationQueryStatus = exports.ShapeDiverRequestModelComputationQueryOrder = exports.ShapeDiverRequestGltfUploadQueryConversion = exports.ShapeDiverRequestLogMessageLevel = exports.ShapeDiverRequestTicketType = void 0;
const SdCommonModel_1 = _SdCommonModel;
const SdCommonModelComputation_1 = _SdCommonModelComputation;
const SdCommonsTicket_1 = _SdCommonsTicket;
exports.ShapeDiverRequestTicketType = Object.assign({}, SdCommonsTicket_1.ShapeDiverCommonsTicketType);
var ShapeDiverRequestLogMessageLevel;
(function (ShapeDiverRequestLogMessageLevel) {
  ShapeDiverRequestLogMessageLevel[ShapeDiverRequestLogMessageLevel["INFO"] = 0] = "INFO";
  ShapeDiverRequestLogMessageLevel[ShapeDiverRequestLogMessageLevel["WARNING"] = 1] = "WARNING";
  ShapeDiverRequestLogMessageLevel[ShapeDiverRequestLogMessageLevel["ERROR"] = 2] = "ERROR";
})(ShapeDiverRequestLogMessageLevel || (exports.ShapeDiverRequestLogMessageLevel = ShapeDiverRequestLogMessageLevel = {}));
var ShapeDiverRequestGltfUploadQueryConversion;
(function (ShapeDiverRequestGltfUploadQueryConversion) {
  ShapeDiverRequestGltfUploadQueryConversion["NONE"] = "none";
  ShapeDiverRequestGltfUploadQueryConversion["SCENE"] = "scene";
  ShapeDiverRequestGltfUploadQueryConversion["USDZ"] = "usdz";
})(ShapeDiverRequestGltfUploadQueryConversion || (exports.ShapeDiverRequestGltfUploadQueryConversion = ShapeDiverRequestGltfUploadQueryConversion = {}));
var ShapeDiverRequestModelComputationQueryOrder;
(function (ShapeDiverRequestModelComputationQueryOrder) {
  ShapeDiverRequestModelComputationQueryOrder["ASC"] = "asc";
  ShapeDiverRequestModelComputationQueryOrder["DESC"] = "desc";
})(ShapeDiverRequestModelComputationQueryOrder || (exports.ShapeDiverRequestModelComputationQueryOrder = ShapeDiverRequestModelComputationQueryOrder = {}));
var ShapeDiverRequestModelComputationQueryStatus;
(function (ShapeDiverRequestModelComputationQueryStatus) {
  ShapeDiverRequestModelComputationQueryStatus["SUCCESS"] = "success";
  ShapeDiverRequestModelComputationQueryStatus["TIMEOUT"] = "timeout";
  ShapeDiverRequestModelComputationQueryStatus["OTHER"] = "other";
  ShapeDiverRequestModelComputationQueryStatus["ALL"] = "*";
})(ShapeDiverRequestModelComputationQueryStatus || (exports.ShapeDiverRequestModelComputationQueryStatus = ShapeDiverRequestModelComputationQueryStatus = {}));
var ShapeDiverRequestModelComputationQueryType;
(function (ShapeDiverRequestModelComputationQueryType) {
  ShapeDiverRequestModelComputationQueryType["COMPUTATION"] = "computation";
  ShapeDiverRequestModelComputationQueryType["EXPORT"] = "export";
  ShapeDiverRequestModelComputationQueryType["LOAD"] = "load";
  ShapeDiverRequestModelComputationQueryType["ALL"] = "*";
})(ShapeDiverRequestModelComputationQueryType || (exports.ShapeDiverRequestModelComputationQueryType = ShapeDiverRequestModelComputationQueryType = {}));
exports.ShapeDiverRequestQueryModelStatus = Object.assign({}, SdCommonModel_1.ShapeDiverCommonsModelStatus);
exports.ShapeDiverRequestQueryModelComputationStatus = Object.assign({}, SdCommonModelComputation_1.ShapeDiverCommonsModelComputationStatus);
//# sourceMappingURL=SdRequestDto.js.map
export default exports;